export enum _SortingEnum {
	name = 'name',
	price = 'price',
	avail = 'avail',
	recommended = 'recommended'
}

export enum _SearchTypeEnum {
	Articles = 'articles',
	Blog = 'blog',
	Scooters = 'scooters',
	Pages = 'pages'
}

export const _CategoriesEnum = {
	universal: 1,
	used: 2,
	new: 3
};

export enum _CategoriesEnum_t {
	UNI = 'univerzalni-dily',
	USED = 'pouzite-dily',
	NEW = 'nahradni-dily'
}

export const _AvailabilityEnum = {
	skladem: 'skladem',
	dodavatel: 'u dodavatele',
	nedostupne: 'nedostupné',
	objednavka: 'na objednávku'
};

export enum _Subcategory_t_new {}
